export default (pageClass) => {
  return document.body.classList.contains(pageClass);
};
